export default __webpack_public_path__ + "static/media/Moon.d54daf42.svg";